const state = {
  round: 0,
  requiredNums: ["-","-","-","-","-"],
  requiredFails: ["-","-","-","-","-"],
  assinedUsers: [],
  prevotes: [],
  currentVotes: [],
  votes: [],
  voting: false,
  result: [],
  missionExecuters: [],
  missionCards: [],
  winner: "",
}

const getters = {
  round: state => state.round,
  result: state => state.result,
  requiredFails: state => state.requiredFails,
  assignedUsers: state => state.assignedUsers,
  prevotes: state => state.prevotes,
  votes: state => state.votes,
  currentRequiredNum: state => {
      return state.requiredNums[state.round - 1]
  },
  currentRequiredFail: state => {
      return state.requiredFails[state.round - 1]
  }
}

const actions = {
  setMissionRequirement({ commit }) {
    commit('setMissionRequirement')
  },
  proceedRound({ commit }) {
    commit('proceedRound')
  },
  setAssignedUsers({ commit }){
    commit('setAssignedUsers')
  },
  setPrevotes({ commit }){
    commit('setPrevotes')
  },
  setMissionCards({ commit }){
    commit('setMissionCards')
  },
  setVotes({ commit }){
    commit('setVotes')
  },
  setVoting({ commit }){
    commit('setVoting')
  },
  setNotVoting({ commit }){
    commit('setNotVoting')
  },
  setResult({ commit }) {
    commit('setResult')
  },
  setWinner({ commit }) {
    commit('setWinner')
  },
  clearMissionInfo({ commit }){
    commit('clearMissionInfo')
  }
}

const mutations = {
  setMissionRequirement(state, payload) {
    console.log(payload)
    state.result = []
    switch (payload){
      case 5:
        state.requiredNums = [2,3,2,3,3]
        state.requiredFails = [1,1,1,1,1]
        break
      case 6:
        state.requiredNums = [2,3,4,3,4]
        state.requiredFails = [1,1,1,1,1]
        break
      case 7:
        state.requiredNums = [2,3,3,4,4]
        state.requiredFails = [1,1,1,2,1]
        break
      case 8:
        state.requiredNums = [3,4,4,5,5]
        state.requiredFails = [1,1,1,2,1]
        break
      case 9:
        state.requiredNums = [3,4,4,5,5]
        state.requiredFails = [1,1,1,2,1]
        break
      case 10:
        state.requiredNums = [3,4,4,5,5]
        state.requiredFails = [1,1,1,2,1]
        break
    }
  },
  proceedRound(){
    state.round++
  },
  setAssignedUsers(state, users){
    state.assignedUsers = []
    for (var i in users){
      state.assignedUsers.push(users[i])
    }
  },
  setPrevotes(state, votes){
    state.prevotes = []
    for (var i in votes){
      state.prevotes.push({id: votes[i].id, name: votes[i].name, vote: votes[i].vote})
    }
  },
  setVotes(state, payload){
    const leader = payload.leader
    const votes = payload.votes
    const assigned = payload.assigned
    var currentVotes = []
    state.currentVotes = []
    // for (var j in state.prevotes){
    //   currentVotes.push({name:state.prevotes[j].name, vote:state.prevotes[j].vote})
    // }
    for (var i=0; i<votes.length; i++){
      state.currentVotes.push({id: votes[i].id, name: votes[i].name, vote: votes[i].vote})

      var isPrevoted = false
      for (var prevote of state.prevotes){
        if (prevote.id == votes[i].id){
          isPrevoted = true
        }
      }
      currentVotes.push({id: votes[i].id, name:votes[i].name, vote:votes[i].vote, prevote: isPrevoted})
    }
    state.votes[state.round].votes.push(currentVotes)

    var assignedUsers = []
    for (i=0; i<assigned.length; i++){
      assignedUsers.push({id: assigned[i].id, name: assigned[i].name})
    }
    state.votes[state.round].assigned.push(assignedUsers)

    state.votes[state.round].leader.push(leader)
  },
  clearVotes(state){
    state.votes = [{round: 1, votes:[], assigned:[], leader:[]},{round: 2, votes:[], assigned:[], leader:[]},{round: 3, votes:[], assigned:[], leader:[]},{round: 4, votes:[], assigned:[], leader:[]},{round: 5, votes:[], assigned:[], leader:[]}]
  },
  setResult(state, payload) {
    state.result.splice(payload.round, 1, payload.result)
    // state.result[payload.round] = payload.result
    state.round += 1

    state.missionExecuters.push(state.assignedUsers)
  },
  setMissionCards(state, payload) {
    state.missionCards.push(payload.missionCards)
  },
  setVoting(state) {
    state.voting = true
  },
  setNotVoting(state) {
    state.voting = false
  },
  setWinner(state, payload) {
    state.winner = payload.winner
  },
  clearMissionInfo(state) {
    state.round = 0
    state.requiredNums = ["-","-","-","-","-"]
    state.requiredFails = ["-","-","-","-","-"]
    state.assinedUsers = []
    state.prevotes = []
    state.votes = []
    state.result = []
    state.missionExecuters = []
    state.winner = ""
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
